import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Route from "./route";
import "@fontsource/manrope";
import "@fontsource/syne";
import "primereact/resources/themes/lara-light-blue/theme.css"; 
import "primereact/resources/primereact.min.css"; 

function App() {
  return (
    <BrowserRouter>
      <Route />
    </BrowserRouter>
  );
}

export default App;
